module.exports = __webpack_public_path__ + "img/brand15.1974bd33.jpg";